import Swiper from 'swiper';
import { Pagination, A11y } from 'swiper/modules';
import BackgroundVideo from '../components/BackgroundVideo';
import ConvertHeight from '../components/ConvertHeight';
import { trackingControlUI, trackingEvent } from '../utils';

export default class ModGallery {
  constructor(el) {
    this.$el = $(el);
    window.playerVideoGallery = [];

    this.classes = {
      swiperWrapper: 'swiper-wrapper',
      firstSlider: 'first-slider',
      lastSlider: 'last-slider',
      popupGallery: 'gallery-popup',
      activeSound: 'active-sound',
      raiderInfo: 'mod-rider-info',
    };

    this.elementClasses = {
      videoGallery: '.js-video-gallery',
      cursorIcon: '.cursor-icon',
      imgNotVideo: '.img-not-video',
      itemGalleryPopup: '.item-gallery-item',
    };

    this.dom = {
      $body: $('body'),
      $swiperEl: this.$el.find('.middle-gallery'),
      $popupGallery: this.$el.find('.gallery-popup'),
      $pagination: this.$el.find('.swiper-pagination'),
      $itemGalleryPopup: this.$el.find('.item-gallery-item'),
      $videos: this.$el.find(this.elementClasses.videoGallery),
      $buttonControlSound: this.$el.find('.btn-control-sound'),
      $isOpen: this.$el.find('.popup-is-open'),
      $equalHeight: this.$el.find('.equal-height'),
    };

    this.init();
  }

  init() {
    this.getPlayerVideo();
    this.addListeners();
    this.cloneGalleryItemSlide();
    this.cloneGallery();
    this.addSwiper();
    this.mouseMove();
    this.convertHeight();

    // tracking event after clone gallery
    this.trackingEventGeneralClickChildren();
  }

  addListeners() {
    this.dom.$buttonControlSound.on('click', (event) => {
      this.eventClickButtonControlSound(event);
    });
    this.dom.$isOpen.on('mousemove', this.mouseMove.bind(this));
    this.dom.$isOpen.on('mouseleave', this.mouseLeave.bind(this));
  }

  mouseMove(event) {
    if (event) {
      const $elm = $(event.currentTarget);
      const $icon = $elm.find(this.elementClasses.cursorIcon);
      const $parent = $elm.parents(this.elementClasses.videoGallery);
      if ($parent.find(this.elementClasses.imgNotVideo).length) {
        $icon.css({
          display: 'block',
          top: `${event.offsetY - 30}px`,
          left: `${event.offsetX - 30}px`,
        });
      }
    }
  }

  mouseLeave(event) {
    const $elm = $(event.currentTarget);
    const $icon = $elm.find(this.elementClasses.cursorIcon);
    $icon.css({
      display: 'none',
    });
  }

  getPlayerVideo() {
    this.dom.$videos.each((index, elm) => {
      const player = new BackgroundVideo(elm);
      player.init();
      window.playerVideoGallery.push(player);
      $(elm).attr('id', `${index}-${player.id}`);
    });
  }

  cloneGallery() {
    const $popupClone = this.dom.$popupGallery.clone();
    this.dom.$popupGallery.remove();
    $popupClone.appendTo(this.dom.$body);
  }

  trackingEventGeneralClickChildren() {
    const $parents = $('[data-event-trigger-children-gallery]');
    $parents.each((_i, el) => {
      const eventTrigger = $(el).attr('data-event-trigger-children-gallery') || '';
      const eventType = $(el).attr('data-event-type') || '';
      const eventCategory = $(el).attr('data-event-category') || '';
      const eventModule = $(el).attr('data-event-module') || '';
      const eventTriggerElement = $(el).attr('data-event-trigger-element') || '';
      const eventLabelType = $(el).attr('data-event-label-type') || '';
      const eventLabelGet = $(el).attr('data-event-label-get') || '';

      $(el).on('click', eventTriggerElement, (e) => {
        const $target = $(e.currentTarget);
        if (eventTrigger) {
          let eventLabel = $target.text().trim();
          if (eventLabelType === 'attribute' && eventLabelGet) {
            eventLabel = $target.attr(eventLabelGet);
          }
          trackingEvent({
            event: eventTrigger,
            type: eventType,
            label: `${window.pageName}:${eventModule}:${eventLabel}`,
            category: eventCategory,
          });
        }
      });
    });
  }

  cloneGalleryItemSlide() {
    this.dom.$popupGallery.each((_index, elm) => {
      const $popupGallery = $(elm);
      if ($popupGallery.find(this.elementClasses.itemGalleryPopup).length > 1) {
        const lastItemClone = $popupGallery.find(this.elementClasses.itemGalleryPopup).last().addClass(this.classes.lastSlider).clone().addClass('clone-slide');
        const firstItemClone = $popupGallery.find(this.elementClasses.itemGalleryPopup).eq(0).addClass(this.classes.firstSlider).clone().addClass('clone-slide');
        lastItemClone.prependTo($popupGallery.find(`.${this.classes.swiperWrapper}`));
        firstItemClone.appendTo($popupGallery.find(`.${this.classes.swiperWrapper}`));
      }
    });
  }

  addSwiper() {
    if (this.dom.$swiperEl.length) {
      const swiperElm = this.dom.$swiperEl.get(0);
      const paginationElm = this.dom.$pagination.get(0);
      this.mySwiper = new Swiper(swiperElm, {
        modules: [Pagination, A11y],
        slidesPerView: 1,
        speed: 700,
        breakpoints: {
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
        },
        pagination: {
          el: paginationElm,
          clickable: true,
        },
      });
    }
  }

  eventClickButtonControlSound(event) {
    const $elementCurrentTarget = $(event.currentTarget);
    const idVideoCurrent = $elementCurrentTarget.closest(this.elementClasses.videoGallery).attr('id');
    let playerCurrentClick;

    window.playerVideoGallery.forEach((player) => {
      const videoItemId = $(player.$el).attr('id');
      if (idVideoCurrent === videoItemId) {
        playerCurrentClick = player;
      } else {
        player.muteVideo();
      }
    });

    if (playerCurrentClick) {
      if ($elementCurrentTarget.hasClass(this.classes.activeSound)) {
        playerCurrentClick.muteVideo();
        trackingControlUI($elementCurrentTarget, 'mute video');
      } else {
        playerCurrentClick.unMuteVideo();
        trackingControlUI($elementCurrentTarget, 'unmute video');
      }
    }
  }

  convertHeight() {
    const convertHeight = new ConvertHeight(this.dom.$equalHeight);
    convertHeight.initialize();
  }
}
